import { AbstractControl } from '@angular/forms';

export const cep = (control: AbstractControl) => {
  const { value } = control;

  if (!value) return null;

  const cep = String(value).replace(/\D/g, '');

  if (cep && cep?.length === 8) return null;

  return { cep: { message: 'CEP inválido' } };
};
